import { ObservableArray, View, ViewModel } from "binder"
import { ElementType, SelectorBaseViewModel } from "./selectorBase-viewModel"

export class SelectorBaseView<T extends ElementType> extends View<SelectorBaseViewModel<T>>{
    GetViewUniqueId(): string {
        return "V-A3140EAC-88E9-4CCD-90EA-7150444E9BF1"
    }
    loadHtml(): string {
        let element = require('./selectorBase.html').default;
        let style = require('./selectorBase.less');
        return element;
    }
    constructor() {
       super();
    }

    public set items(v: ObservableArray<T>) { this._items = v; } public get items(): ObservableArray<T> { return this._items;} private _items: ObservableArray<T>;
    public set selectedItem(v: T) { this._selectedItem = v; } public get selectedItem(): T { return this._selectedItem;} private _selectedItem: T;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;

    requestRefresh(){
        this.dataContext.requestRefresh();
    }
}
